var angular = require('angular');
var templateUrl = require('./appSignup.ng.html');
require('angular-sanitize'); 
require('./appSignup.less');
require('../appSelectCompany/appSelectCompany.js');
require('../appSelectRegion/appSelectRegion.js');
require('../appSelectSport/appSelectSport.js');
var $ = require('jquery');
window.$ = $;
var register = require('_services/registerSvc.js');
var _ = require("underscore");
var moment = require("moment");

var app = angular.module("app-signup", ['app-select-company','app-select-region','app-select-sport']);
 
app.directive('appSignup', function() {
    return {
        restrict: 'E',
        templateUrl: templateUrl,
        controller: ["$scope", "$q", "$http", "$timeout", function($scope, $q, $http, $timeout){

          moment.locale("ru");
					$scope.dateMax = moment().subtract(18, 'years').calendar()
					$scope.maxYear = +moment($scope.dateMax, "DD.MM.YYYY").format("YYYY")
					$scope.maxMonth = +moment($scope.dateMax, "DD.MM.YYYY").format("MM")
					$scope.maxDay = +moment($scope.dateMax, "DD.MM.YYYY").format("DD")

					$scope.dateMin = moment().subtract(100, 'years').calendar()
					$scope.minYear = +moment($scope.dateMin, "DD.MM.YYYY").format("YYYY")
					$scope.minMonth = +moment($scope.dateMin, "DD.MM.YYYY").format("MM")
					$scope.minDay = +moment($scope.dateMin, "DD.MM.YYYY").format("DD")

          $scope.click = 0;
          $scope.user = {name:'', password:'', password2:'', email:'', organization:'', ogrn: '', tel: '',
          company:'', sport:'', region:'', description:'', key: '',
          dateBirth:{day:'',month:'',year:''},
        	fio:{surname:'',name:'',patronymic:''},
        	sex:'m'}; 
        	
          $scope.response = {
          	message : "",
          	secondsBeforeQuit : 30
          };
          $scope.extraClass = {};
          $scope.date = {};
          
          standartDateThreshold();

          $scope.fromNowToDateBirth = function() {
			var formatDate = moment($scope.user.dateBirth.day + '.' + 
				$scope.user.dateBirth.month + '.' + $scope.user.dateBirth.year,
				"DD.MM.YYYY").fromNow();
			formatDate = formatDate.replace(" назад", "");
			return formatDate;
          }

          $scope.onMonthChange = function() {
          	if (+$scope.user.dateBirth.year === $scope.maxYear) {
          		if (+$scope.user.dateBirth.month === $scope.maxMonth) {
	      				$scope.date.day = _.map(_.range($scope.maxDay), function(x) {
			          	var day = x < 9 ? "0" + (x+1) : x+1;
			        		return {
			          		day
			        		};
			      		});

			      		if ($scope.user.dateBirth.day !== "" &&
		      			    +$scope.user.dateBirth.day > $scope.maxDay)
		      			  $scope.user.dateBirth.day = $scope.maxDay <= 9 ? 
		      				  "0" + $scope.maxDay : "" + $scope.maxDay
		      		}
		      		else {
		      			var days = daysInMonth();

			          $scope.date.day = _.map(_.range(days), function(x) {
			          	var day = x < 9 ? "0" + (x+1) : x+1;
			        		return {
			          		day
			        		};
			      		});
		      		}
          	}

          	else if (+$scope.user.dateBirth.year === $scope.minYear) {
          		if (+$scope.user.dateBirth.month === $scope.minMonth) {
		      			var days = daysInMonth();

			      		$scope.date.day = _.map(_.range(days+1 - $scope.minDay), function(x) {
			      			x = x + $scope.minDay;
			          	var day = x <= 9 ? "0" + (x) : x;
			        		return {
			          		day
			        		};
			      		});
			      		
			      		if ($scope.user.dateBirth.day !== "" &&
			      			+$scope.user.dateBirth.day < $scope.minDay)
			      			$scope.user.dateBirth.day = $scope.minDay <= 9 ? 
			      				"0" + $scope.minDay : "" + $scope.minDay 
		      		}
		      		else {
		      			var days = daysInMonth();

			          $scope.date.day = _.map(_.range(days), function(x) {
			          	var day = x < 9 ? "0" + (x+1) : x+1;
			        		return {
			          		day
			        		};
			      		});
		      		}
          	}

          	else 
          		standartDateThreshold();

          	var days = daysInMonth();
          	if ($scope.user.dateBirth.day !== "" &&
		      			+$scope.user.dateBirth.day > days)
		      		$scope.user.dateBirth.day = days <= 9 ? 
		      			"0" + days : "" + days;
          }

          $scope.onYearChange = function() {
          	if (+$scope.user.dateBirth.year === $scope.maxYear) {
          		$scope.date.month = _.map(_.range($scope.maxMonth), function(x) {
		          	var month = x < 9 ? "0" + (x+1) : x+1;
		        		return {
		          		month
		        		};
		      		});

		      		if ($scope.user.dateBirth.month !== "" && 
		      			  +$scope.user.dateBirth.month > $scope.maxMonth) {
	      				$scope.user.dateBirth.month = $scope.maxMonth <= 9 ? 
	      					"0" + $scope.maxMonth : "" + $scope.maxMonth
	      			}

	      			if (+$scope.user.dateBirth.month === $scope.maxMonth) {
	      				$scope.date.day = _.map(_.range($scope.maxDay), function(x) {
			          	var day = x < 9 ? "0" + (x+1) : x+1;
			        		return {
			          		day
			        		};
			      		});

			      		if ($scope.user.dateBirth.day !== "" &&
		      			    +$scope.user.dateBirth.day > $scope.maxDay)
		      			  $scope.user.dateBirth.day = $scope.maxDay <= 9 ? 
		      				  "0" + $scope.maxDay : "" + $scope.maxDay
		      		}	
          	}

          	else if (+$scope.user.dateBirth.year === $scope.minYear) {
          		$scope.date.month = _.map(_.range(13 - $scope.minMonth), function(x) {
          			x = x + $scope.minMonth;
		          	var month = x <= 9 ? "0" + (x) : x;
		        		return {
		          		month
		        		};
		      		});

              if ($scope.user.dateBirth.month !== "" &&
              	  +$scope.user.dateBirth.month < $scope.minMonth) { 
		      			$scope.user.dateBirth.month = $scope.minMonth <= 9 ? 
		      				"0" + $scope.minMonth : "" + $scope.minMonth 
		      		}

		      		if (+$scope.user.dateBirth.month === $scope.minMonth) {
		      			var days = daysInMonth();

			      		$scope.date.day = _.map(_.range(days+1 - $scope.minDay), function(x) {
			      			x = x + $scope.minDay;
			          	var day = x <= 9 ? "0" + (x) : x;
			        		return {
			          		day
			        		};
			      		});
			      		
			      		if ($scope.user.dateBirth.day !== "" &&
			      			+$scope.user.dateBirth.day < $scope.minDay)
			      			$scope.user.dateBirth.day = $scope.minDay <= 9 ? 
			      				"0" + $scope.minDay : "" + $scope.minDay 
		      		}
          	}

          	else 
          		standartDateThreshold();
          }
          
          function standartDateThreshold() {
	          $scope.date.month = _.map(_.range(12), function(x) {
	          	var month = x < 9 ? "0" + (x+1) : x+1;
	        		return {
	          		month
	        		};
	      		});

	      		var days;
	      		if ($scope.user.dateBirth.month === "")
	      			days = 31;
	      		else
	      			days = daysInMonth();

	          $scope.date.day = _.map(_.range(days), function(x) {
	          	var day = x < 9 ? "0" + (x+1) : x+1;
	        		return {
	          		day
	        		};
	      		});

	      		$scope.date.year = _.map(_.range($scope.maxYear+1 - $scope.minYear), function(x) {
	          	var year = $scope.maxYear - x;
	        		return {
	          		year
	        		};
	      		});
          }

          function daysInMonth() {
          	var days = 31;
          	switch ($scope.user.dateBirth.month) {
			        case "01":
		            days = 31;
		            break;
			        case "02":
		            days = 29;
		            break;
			        case "03":
		            days = 31;
		            break;
			        case "04":
		            days = 30;
		            break;
			        case "05":
		            days = 31;
		            break;
			        case "06":
		            days = 30;
		            break;
			        case "07":
		            days = 31;
		            break;
			        case "08":
		            days = 31;
		            break;
			        case "09":
		            days = 30;
		            break;
			        case "10":
		            days = 31;
		            break;
			        case "11":
		            days = 30;
		            break;
			        case "12":
		            days = 31;
		            break;
			        default:
			          days = 31;
				    }
				    return days;
          }
          

		  $scope.changeForm = function(n){
		  	$scope.click = n;
		  	if ($scope.click === 0) {
		  		$scope.user.name = '';
		  		$scope.user.password = '';
		  		$scope.user.password2 = '';
		  		$scope.user.email = '';

		  		$scope.user.company = {},

		  		$scope.user.sport = {},
		  		$scope.user.region = {},
		  		$scope.user.description = '',

		  		$scope.user.organization = '';
		  		$scope.user.ogrn = '';
		  		$scope.user.tel = '';
		  		$scope.user.key = '';
		  		$scope.user.dateBirth.day = '',
		  		$scope.user.dateBirth.month = '',
		  		$scope.user.dateBirth.year = '',
		  		$scope.user.fio.surname = '',
		  		$scope.user.fio.name = '',
		  		$scope.user.fio.patronymic = '',
		  		$scope.user.sex = 'm',


		  		$scope.response.message = '';
					$scope.response.loaded = false;
					$scope.response.sport = false;
					$scope.response.secondsBeforeQuit = 30;
					$scope.response.good = false;
					$scope.response.url = "";
					$scope.response.data = undefined;

					$scope.extraClass = {};
				}
		  }      	  	

		  $scope.extraClassOff = function(input){
		  	if (input === 'name') {
		  		$scope.extraClass.name = false;
		  	}
		  	else if (input === 'password') {
		  		$scope.extraClass.password = false;
		  	}
		  	else if (input === 'password2') {
		  		$scope.extraClass.password2 = false;
		  	}
		  	else if (input === 'email') {
		  		$scope.extraClass.email = false;
		  	}
		  	else if (input === 'organization') {
		  		$scope.extraClass.organization = false;
		  	}
		  	else if (input === 'ogrn') {
		  		$scope.extraClass.ogrn = false;
		  	}
		  	else if (input === 'key') {
		  		$scope.extraClass.key = false;
		  	}
		  	else if (input === 'fioSurname') {
		  		$scope.extraClass.fioSurname = false;
		  	}
		  	else if (input === 'fioName') {
		  		$scope.extraClass.fioName = false;
		  	}
		  	else if (input === 'fioPatronymic') {
		  		$scope.extraClass.fioPatronymic = false;
		  	}
		  }
		  
		  $scope.extraClassOn = function(input) {
		  	if (input === 'name') {
		  		$scope.extraClass.name = true;
		  	}
		  	else if (input === 'password') {
		  		$scope.extraClass.password = true;
		  	}
		  	else if (input === 'password2') {
		  		$scope.extraClass.password2 = true;
		  	}
		  	else if (input === 'email') {
		  		$scope.extraClass.email = true;
		  	}
		  	else if (input === 'organization') {
		  		$scope.extraClass.organization = true;
		  	}
		  	else if (input === 'ogrn') {
		  		$scope.extraClass.ogrn = true;
		  	}
		  	else if (input === 'key') {
		  		$scope.extraClass.key = true;
		  	}
		  	else if (input === 'fioSurname') {
		  		$scope.extraClass.fioSurname = true;
		  	}
		  	else if (input === 'fioName') {
		  		$scope.extraClass.fioName = true;
		  	}
		  	else if (input === 'fioPatronymic') {
		  		$scope.extraClass.fioPatronymic = true;
		  	}
		  }

		  $scope.errorMessageDisappearanceFix = function(n) {
		  	if (n === 1 || n === 2 || n===4 || n===5) {
		  		if ($scope.response.message === 'Этот email уже занят - попробуйте другой')
		  			$scope.extraClass.goodInput = true;
		  	}
		  	if (n === 3) {
		  		if ($scope.response.message === 'Нам уже пришел запрос с этого email')
		  			$scope.extraClass.goodInput = true;
		  	}
		  	if (n === 4) {
		  		if ($scope.response.message === 'Код введен неверно')
		  			$scope.extraClass.goodInput = true;
		  	}
		  	/*else {
		  		if ($scope.response.message === 'Пользователь с таким email не зарегистрирован')
		  			$scope.extraClass.goodInput = true;
		  	}*/
		  }

		  $scope.registerAccaunt = function(n, validForm){
		  	
		  	if (!validForm ||
		  		((n === 1 || n === 2 || n === 5) && $scope.user.password !== $scope.user.password2)
		  		|| (n === 2 && $scope.user.company === '')
		  		|| (n === 4 && ($scope.user.dateBirth.day === '' || $scope.user.dateBirth.month === ''
		  		|| $scope.user.dateBirth.year === '')) ){
		  		if (n === 1 || n === 2 || n === 5) {
		  			$scope.extraClass.name = true;
		  			$scope.extraClass.password = true;
		  			$scope.extraClass.password2 = true;
		  			$scope.extraClass.email = true;
		  			if (n === 2 && $scope.user.company === '') {
		  				$scope.extraClass.company = true;
				  		return;
		  			}
		  		}
		  		else if (n === 3) {
		  			$scope.extraClass.email = true;
		  			$scope.extraClass.organization= true;
		  			$scope.extraClass.ogrn= true;
		  		}
		  		else if (n === 4) {
		  			$scope.extraClass.email = true;
		  			$scope.extraClass.key = true;
		  			if (n === 4 && ($scope.user.dateBirth.day === '' || $scope.user.dateBirth.month === ''
		  				|| $scope.user.dateBirth.year === '')) {
		  				$scope.extraClass.dateBirth = true;
				  		return;
		  			}
		  		}
		  		//$('#email').focus();
		  		return;
		  	}
		  	
		  	

		  	$scope.response.loading = true;

		  	register($scope.user, $q, $http, n).then(function(data) {
		  		data.url = data.url || "/";
		  		if (n!==4) {
						$scope.response.good = true;
		  			$scope.response.message = data.message;
		  			$scope.response.url = data.url;
		  			if (n === 40) {
		  				$scope.click = 4;
		  				$scope.response.data = undefined;
		  			}
		  			successLeaveRegistrationTimer();
		  		}
		  		else if (n===4){
		  			$scope.response.good = true;
		  			$scope.response.data = data.data;
		  			$scope.response.message = "";
		  			$scope.response.url = data.url;
		  			$scope.click = 40;
		  		}

		  	}, function(data) {
					$scope.response.good = false;
		  		$scope.response.message = data.message;
		  	}).finally(function(){
		  		$scope.response.loading = false;
		  		$scope.response.loaded = true;
		  		$scope.extraClass.goodInput = false;
		  		if (n === 1 || n === 2 || n === 5) {
		  			$scope.extraClass.name = true;
		  			$scope.extraClass.password = true;
		  			$scope.extraClass.password2 = true;
		  			$scope.extraClass.email = true;
		  		}
		  		else if (n === 3) {
		  			$scope.extraClass.email = true;
		  			$scope.extraClass.organization= true;
		  			$scope.extraClass.ogrn= true;
		  		}
		  		else if (n === 4) {
		  			$scope.extraClass.email = true;
		  			$scope.extraClass.key = true;
		  			$scope.extraClass.dateBirth = true;
		  			$scope.extraClass.fioSurname = true;
		  			$scope.extraClass.fioName = true;
		  			$scope.extraClass.fioPatronymic = true;
		  		}
		  	});
		  }

		  $scope.transitionSport = function(){
		  	if ($scope.response.sport) {
		  		var id=document.getElementById("uiSelectSport");
		  		id.style.width='100%'; 
					id.style.height='51px'; 
					id.style.opacity='1';
					id.style.margin='0 0 15px 0';
					if ($scope.response.sportModel !== "") {
						$scope.user.sport = $scope.response.sportModel;
					}                
				}                                                                                                                                                                               
		  	else {
		  		var id=document.getElementById("uiSelectSport");
		  		id.style.width='100%'; 
					id.style.height='0'; 
					id.style.opacity='0';
					id.style["margin"]='0';

					$scope.user.sport = {};
		  	} 
		  }

		  function successLeaveRegistrationTimer() {
		  	var countUp = function() {
		  		if ($scope.response.url !== "") {
		  			$scope.response.secondsBeforeQuit-= 1;

		  			if ($scope.response.secondsBeforeQuit > 0) {
		  				$timeout(countUp, 1000);
		  			}
		  			else {
		  				window.location = $scope.response.url;	  		
		  			}
		  		}
		  	}
		  	$timeout(countUp, 1000);
		  }

		  $scope.backToSignUpSportsman = function() {
		  	$scope.response.message = '';
				$scope.response.loaded = false;
				$scope.response.sport = false;
				$scope.response.secondsBeforeQuit = 30;
				$scope.response.good = false;
				$scope.response.url = "";
				$scope.response.data = undefined;

				$scope.extraClass = {};
		  }

		  $scope.passwordGenerate = function() {
		  	var dict: String = "abcdefghijklmnopqrstuvwxyz0123456789";
    		var password: String = "";
    		var random;

    		var i;
    		for (i = 0; i < 6; i++) {
    			random = Math.floor((Math.random() * 36) + 1);
      		password = password + dict.charAt(random);
    		}
    		$scope.user.password = password;
    		$scope.user.password2 = password;
    		$scope.extraClass.password = true;
		  	$scope.extraClass.password2 = true;
		  }

		  $scope.$watch("response.sportModel", function(newValue){
	  	  $scope.user.sport = newValue;
	    }); 
	    $scope.$watch("response.region", function(newValue){
	  	  $scope.user.region = newValue;
	    });

    }]
  }
});



/** WEBPACK FOOTER **
 ** ./_directives/appSignup/appSignup.js
 **/